module.exports = __webpack_public_path__ + "img/onBehavior.1f1160d2.png";